import React from 'react';

export default {
  width: 11,
  height: 7,
  content: (
    <path d="M9.1019297.3212502l1.4046501 1.4237127-5.1222069 5.0536236L.2928932 1.7071068 1.7071068.2928932l3.6867655 3.6867656z" />
  )
};
